export const API_SEND_TO_USERS = '/bulk-email/send';
export const API_SEND_TO_INITIATOR = '/bulk-email/test-send';
